import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './QuickPick.css';
import Cookies from 'js-cookie';
import 'font-awesome/css/font-awesome.min.css';

const EditWatchList = () => {
    const [watchList, setWatchList] = useState([]);
    const [library, setLibrary] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [undoAvailable, setUndoAvailable] = useState({});
    const [oldestItems, setOldestItems] = useState([]);
    const username = Cookies.get("username") || 'default';
    const location = useLocation();
    const [mediaType, setMediaType] = useState(null);
    const [sortMode, setSortMode] = useState('alphabetical');

    const handleQuickPickSelection = (type) => {
        window.location.href = `/quick-pick?m=${type}`;
    };

    const gotoPublicPage = (type) => {
        window.location.href = `/watchlist?w=${username}&m=${type}`;
    };

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const mediaTypeParam = searchParams.get('m');
        if (mediaTypeParam === 'tv-shows' || mediaTypeParam === 'movies') {
            setMediaType(mediaTypeParam);
            const storedList = localStorage.getItem(`sortedWatchList-${mediaTypeParam}`);
            const parsedList = storedList ? JSON.parse(storedList) : [];
            setWatchList(parsedList);

            fetch(`/api/watchlist/${username}`)
                .then(response => response.json())
                .then(data => {
                    const list = data[mediaTypeParam]?.map(item => ({ ...item[1], id: item[0] })) || [];
                    const uniqueList = removeDuplicates(list, parsedList);
                    setLibrary(uniqueList);
                    setIsLoading(false);
                })
                .catch(error => {
                    console.error('Error fetching watchlist:', error);
                    setIsLoading(false);
                });

            // Fetch oldest media for the selected media type
            fetch(`/api/oldest-media?m=${mediaTypeParam}`)
                .then(response => response.json())
                .then(data => {
                    const list = data?.map(item => item[1]) || [];
                    setOldestItems(list);
                })
                .catch(error => console.error('Error fetching oldest media:', error));
        }
    }, [location.search, username]);

    useEffect(() => {
        if (mediaType) {
            localStorage.setItem(`sortedWatchList-${mediaType}`, JSON.stringify(watchList));
        }
    }, [watchList, mediaType]);

    useEffect(() => {
        if (mediaType) {
            localStorage.setItem(`library-${mediaType}`, JSON.stringify(library));
        }
    }, [library, mediaType]);

    const removeDuplicates = (list1, list2) => {
        const seen = new Set(list2.map(item => item.tmdb_id));
        return list1.filter(item => !seen.has(item.tmdb_id));
    };

    const handleWatchSoon = (tmdbId, fromLibrary) => {
        if (fromLibrary) {
            const item = library.find(item => item.tmdb_id === tmdbId);
            if (!item) return;
            setWatchList(prev => [...prev, item]);
            setLibrary(prev => prev.filter(i => i.tmdb_id !== tmdbId));
        } else {
            const item = watchList.find(item => item.tmdb_id === tmdbId);
            if (!item) return;
            setWatchList(prev => [...prev.filter(i => i.tmdb_id !== tmdbId), item]);
        }
    };
    const moveToPosition = (currentIndex, targetPosition) => {
        setWatchList((prevWatchList) => {
            if (targetPosition < 1 || targetPosition > prevWatchList.length) {
                return prevWatchList;
            }
            const item = prevWatchList[currentIndex];
            const filteredList = prevWatchList.filter((_, i) => i !== currentIndex);
            const newWatchList = [
                ...filteredList.slice(0, targetPosition - 1),
                item,
                ...filteredList.slice(targetPosition - 1),
            ];
            localStorage.setItem(`sortedWatchList-${mediaType}`, JSON.stringify(newWatchList));
            return newWatchList;
        });
    };
    const handleDeleteItem = (docId, fromLibrary) => {
        if (window.confirm("Are you sure you want to delete this item?")) {
            fetch(`/w/${username}/delete/${docId}`, { method: 'GET' })
                .then(response => response.json())
                .then(data => console.log('Deleted:', data))
                .catch(error => console.error('Error deleting item:', error));

            if (fromLibrary) {
                setLibrary(prev => prev.filter(item => item.id !== docId));
            } else {
                setWatchList(prev => prev.filter(item => item.id !== docId));
            }
        }
    };

    const scrollContainer = (direction, id) => {
        const el = document.getElementById(id);
        if (el) {
            el.scrollBy({ left: direction === 'left' ? -600 : 600, behavior: 'smooth' });
        }
    };

    return (
        <div className="watchlist-game">

            {isLoading ? (
                <p style={{paddingTop:"30px"}} >Loading watchlist...</p>
            ) : (
                <>
                    <div className="media-toggle-bar" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '20px 0' }}>
                        <div className="media-toggle">
                            <button
                                onClick={() => setMediaType('tv-shows')}
                                className={`media-toggle-button ${mediaType === 'tv-shows' ? 'active' : ''}`}
                            >
                                TV
                            </button>
                            <button
                                onClick={() => setMediaType('movies')}
                                className={`media-toggle-button ${mediaType === 'movies' ? 'active' : ''}`}
                            >
                                Movies
                            </button>
                        </div>
                        <div className="discover-group" style={{ display: 'flex', gap: '10px' }}>
                            <button className="discover-btn active" disabled>Top Picks</button>
                            <a href={`/quick-pick?m=${mediaType}`} className="discover-btn">Quick Pick</a>
                            <a href={`/quick-pick-elimination?m=${mediaType}`} className="discover-btn">Watchlist</a>
                            <button onClick={() => window.location.href = `/search?section=${mediaType === 'tv-shows' ? 'tv' : 'movies'}`} className="discover-btn">Discover</button>
                        </div>
                    </div>
<h1 style={{ fontSize: "36px", fontWeight: "bold", color: "white", margin: "30px 5px 10px" }}>
  {mediaType === 'tv-shows' ? 'TV Shows' : 'Movies'} Watchlist
</h1>
                    <p style={{ color: "lightgray", paddingTop: "20px" }}></p>
                    {/* WATCH NOW SECTION */}
                    <div style={{ display: 'flex', alignItems: 'baseline', marginTop: '20px', marginLeft: '5px' }}>
                        <h2 style={{ fontSize: "28px", fontWeight: "600", color: "white", marginBottom: "10px" }}>Watch Now</h2>
                        <span style={{ marginLeft: "12px", marginRight: "10px", color: "gray", fontSize: "16px" }}>|</span>
                        <a
                            href={`/quick-pick?m=${mediaType}`}
                            style={{ color: "#61dafb", fontSize: "16px", textDecoration: 'none', paddingTop: "3px" }}
                        >
                            QUICK PICK
                        </a>
                    </div>
                    <div style={{ position: "relative" }}>
                        <button className="scroll-arrow left" onClick={() => scrollContainer('left', 'watch-now-container')}>‹</button>
                        <div id="watch-now-container" className="grid-container-all" style={{ overflowY: "hidden" }}>
                            {watchList.filter(item => item && item.tmdb_id).length > 0 ? (
                                watchList.filter(item => item && item.tmdb_id).map((item, index) => (
                                    <div className="grid-item" key={index} style={{ position: "relative" }}>
                                        {/* Display rank for all items */}
                                        <div className="top-rank">
                                            {index + 1}
                                        </div>

                                        {/* Item Image and Details */}
                                        <a
                                            href={`https://www.themoviedb.org/${mediaType === 'tv-shows' ? 'tv' : 'movie'}/${item.tmdb_id}/watch`}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img src={item.full_poster_path} alt={item.title} />
                                        </a>

                                        {/* Buttons for reordering */}
                                        <div className="overlay-buttons">
                                            {[1, 2, 3, 4, 5].map((position) => (
                                                <button
                                                    key={position}
                                                    disabled={index === position - 1}
                                                    onClick={() => moveToPosition(index, position)}
                                                    className={`num-btn btn-overlay ${index === position - 1 ? 'btn-selected' : ''}`}
                                                >
                                                    {position}
                                                </button>
                                            ))}
                                        </div>

                                        <span className="delete-later-btn" onClick={() => {
                                            if (index < watchList.length) {
                                                const itemToMove = watchList[index];
                                                setWatchList(watchList.filter((_, i) => i !== index));
                                                setLibrary([...library, itemToMove]);
                                            }
                                        }}>
                                            <i style={{ color: "red", position: "absolute", top: "0px", left: "0px", fontSize: "40px" }} className="fa fa-times"></i>
                                        </span>
                                    </div>
                                ))
                            ) : (
                                <p style={{ color: "lightgray" }}>Your watch now list is empty.</p>
                            )}
                        </div>
                        <button className="scroll-arrow right" onClick={() => scrollContainer('right', 'watch-now-container')}>›</button>
                    </div>

                    {/* WATCH LATER SECTION */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '40px 10px 10px 10px' }}>
                        <h2 style={{ fontSize: "28px", fontWeight: "600", color: "white", marginBottom: "10px" }}>Watch Later</h2>
                        <div>
                            <span style={{ marginRight: "10px", color: "#ccc" }}>Sort by:</span>
                            <button
                                className="btn btn-sm btn-outline-light"
                                style={{ minWidth: "100px" }}
                                onClick={() => setSortMode(prev => prev === 'alphabetical' ? 'rating' : 'alphabetical')}
                            >
                                {sortMode === 'alphabetical' ? 'A → Z' : '★ Rating'}
                            </button>
                        </div>
                    </div>
                    <div style={{ position: "relative" }}>
                        <div id="watch-later-container" className="grid-container" style={{ overflowY: "hidden" }}>
                            {library.length > 0 ? (
                                [...library]
                                    .filter(item => item && item.tmdb_id)
                                    .sort((a, b) => {
                                      return sortMode === 'rating'
                                        ? (b.vote_average || 0) - (a.vote_average || 0)
                                        : (a.title || '').localeCompare(b.title || '');
                                    })
                                    .map((item, index) => (
                                    <div className="grid-item" key={`library-${index}`} style={{ position: "relative" }}>
                                        <a
                                            href={`https://www.themoviedb.org/${mediaType === 'tv-shows' ? 'tv' : 'movie'}/${item.tmdb_id}/watch`}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img src={item.full_poster_path} alt={item.title} />
                                        </a>
                                        {/* Watch Now button overlay */}
                                        <div className="watch-now-overlay">
                                            <button onClick={() => handleWatchSoon(item.tmdb_id, true)} className="btn-overlay watch-now-btn">
                                                Watch Now
                                            </button>
                                        </div>
                                        <span className="delete-later-btn" onClick={() => handleDeleteItem(item.id, true)}>
                                            <i style={{ color: "red", position: "absolute", top: "0px", left: "0px", fontSize: "40px" }} className="fa fa-times"></i>
                                        </span>
                                    </div>
                                ))
                            ) : (
                                <p style={{ color: "lightgray" }}>Your watch later list is empty.</p>
                            )}
                        </div>
                    </div>

                    {/* OLDEST ITEMS RECOMMENDATION SECTION */}
                    {oldestItems.length > 0 && (
                        <>
                            <div style={{ display: 'flex', marginTop: '40px' }}>
                                <div style={{ fontSize: "30px", color: "lightgray", marginLeft: "5px", marginTop:"10px" }}>
                                    WHAT OTHERS ARE WATCHING
                                </div>
                            </div>
                            <div className="grid-container-all" style={{ overflowY: "hidden" }}>
                                {oldestItems.map((item, index) => (
                                    <div className="grid-item" key={`oldest-${index}`} style={{ position: "relative" }}>
                                        <a
                                            href={`https://www.themoviedb.org/${mediaType === 'tv-shows' ? 'tv' : 'movie'}/${item.tmdb_id}/watch`}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img src={item.full_poster_path} alt={item.title} />
                                        </a>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}

                    <p style={{ color: "lightgray", paddingTop: "20px" }}>Want to share your watchlist with friends?</p>
                    <div className="quick-pick-card" onClick={() => gotoPublicPage(mediaType)}>
                        <button className="btn btn-primary">PUBLIC PAGE </button>
                    </div>
                    <style>{`
                        .watchlist-game {
                            overflow-y: hidden;
                        }

                        .grid-item {
                            position: relative;
                        }

                        .watch-now-overlay {
                            position: absolute;
                            bottom: 5px;
                            left: 0;
                            width: 100%;
                            text-align: center;
                            display: none;
                        }

                        .grid-item:hover .watch-now-overlay {
                            display: block;
                        }

                        .watch-now-btn {
                            background-color: rgba(0, 123, 255, 0.8);
                            color: white;
                            border: none;
                            padding: 5px 10px;
                            border-radius: 4px;
                            cursor: pointer;
                        }

                        .watch-now-btn:hover {
                            background-color: rgba(0, 123, 255, 1);
                        }

                        .scroll-arrow {
                          position: absolute;
                          top: 40%;
                          transform: translateY(-50%);
                          background-color: rgba(0,0,0,0.5);
                          color: white;
                          border: none;
                          z-index: 10;
                          cursor: pointer;
                          padding: 10px;
                          font-size: 24px;
                          border-radius: 50%;
                        }
                        .scroll-arrow.left {
                          left: 0;
                        }
                        .scroll-arrow.right {
                          right: 0;
                        }
                    `}</style>
                </>
            )}
        </div>
    );
};

export default EditWatchList;
